import StoreApplicationState from "@store/Store/StoreApplicationState";
import { useSelector } from "react-redux";

export const useCreditCode = () => {
    return useSelector((state: StoreApplicationState) => {
        const stateContext = state.store.data.creditInformations;
        const creditCode = stateContext.creditInformationModel?.creditCode;
        const creditReasonCode = stateContext.creditInformationModel?.creditReasonCode;
        const isNCreditCode = creditCode === "N";
        const nOpd = isNCreditCode && creditReasonCode === "OPD";
        const nNsf = isNCreditCode && creditReasonCode === "NSF";
        const nNeb = isNCreditCode && creditReasonCode === "NEB";
        const nBad = isNCreditCode && creditReasonCode === "BAD";
        const nIna = isNCreditCode && creditReasonCode === "INA";
        const nNull = isNCreditCode && creditReasonCode === ("" || undefined || null);
        const noCreditCode = !nOpd && !nNsf && !nNeb && !nBad && !nIna && !nNull;

        return {
            isNOpd: nOpd,
            isNNsf: nNsf,
            isNNeb: nNeb,
            isNBad: nBad,
            isNIna: nIna,
            isNNull: nNull,
            isNoCreditCode: noCreditCode,
        };
    });
};

export default useCreditCode;
